import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "/vercel/path0/components/shared/Navbar.tsx");
